/** @format */

export const END_POINT = {
  AUTH: {
    LOGIN: "/login",
    LOGOUT: "/logout",
    ME: "/me",
    REFRESH_TOKEN: "/refresh",
  },
  ACTIVITIES: {
    LIST: "/activities",
  },
  MEMBERS: {
    LIST: "/users",
    SEARCH: "/users/search",
  },
  PROJECTS: {
    LIST: "/projects",
  },
  TAGS: {
    LIST: "/tags",
  },
  TASKS: {
    LIST: "/tasks",
    SEARCH: "/search",
  },
  ACCOUNT_CODES: {
    LIST: "/account-codes",
  },
  PAYMENT_VOUCHERS: {
    LIST: "/payment-vouchers",
  },
  PAYMENT_BANKINGS: {
    LIST: "/payment-bankings",
  },
  OPENING_BALANCE: {
    LIST: "/opening-balance",
  },
  COMPANIES: {
    LIST: "/companies",
  },
  RECEIPT_BANKINGS: {
    LIST: "/receipt-bankings",
  },
  CUSTOMERS: {
    LIST: "/customers",
  },
  DEPARTMENTS: {
    LIST: "/departments",
  },
  EMPLOYEES: {
    LIST: "/employees",
  },
  INVENTORIES: {
    LIST: "/inventories",
  },
  RECEIPTS: {
    LIST: "/receipts",
  },
  RETURN_ORDERS: {
    LIST: "/return-orders",
  },
};

export const headersFormData = {
  Accept: "application/json",
  'Content-Type': 'multipart/form-data',
}
